import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerCard = ({ 
  customer, 
  onEdit, 
  onViewHistory, 
  onScheduleBooking,
  onDelete,
  isSelected,
  onSelect
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(customer?.id, e?.target?.checked)}
            className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth cursor-pointer flex-shrink-0"
            aria-label={`Select ${customer?.name}`}
          />
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-base font-heading font-semibold text-primary">
              {customer?.name?.split(' ')?.map(n => n?.[0])?.join('')?.substring(0, 2)}
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-heading font-semibold text-foreground truncate">
              {customer?.name}
            </h3>
            {customer?.servicePreference && (
              <p className="text-xs text-muted-foreground truncate">
                {customer?.servicePreference}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Phone" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="font-data truncate">{customer?.phone}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Mail" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="truncate">{customer?.email}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Calendar" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="font-data">
            Last: {customer?.lastAppointment || 'Never'}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="TrendingUp" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="font-data font-semibold">
            {customer?.totalVisits} visits
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2 pt-3 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          iconPosition="left"
          onClick={() => onEdit(customer)}
          className="flex-1"
        >
          Edit
        </Button>
        <button
          onClick={() => onViewHistory(customer)}
          className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
          title="View history"
          aria-label={`View history for ${customer?.name}`}
        >
          <Icon name="History" size={20} />
        </button>
        <button
          onClick={() => onScheduleBooking(customer)}
          className="p-2 rounded-lg text-primary hover:bg-primary/10 transition-smooth"
          title="Schedule booking"
          aria-label={`Schedule booking for ${customer?.name}`}
        >
          <Icon name="CalendarPlus" size={20} />
        </button>
        <button
          onClick={() => onDelete(customer?.id)}
          className="p-2 rounded-lg text-error hover:bg-error/10 transition-smooth"
          title="Delete customer"
          aria-label={`Delete ${customer?.name}`}
        >
          <Icon name="Trash2" size={20} />
        </button>
      </div>
    </div>
  );
};

export default CustomerCard;